export default __webpack_public_path__ + "static/media/foodbombLogoChristmas.ffcce24b.png";